"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var FormatTemplatesDropdown_1 = require("./formatTemplatesDropdown/FormatTemplatesDropdown");
var SyntaxHighlightingInput_1 = require("../../syntaxHighlightingInput/SyntaxHighlightingInput");
var formattingRules = {
    start: [
        { regex: /"(?:[^\\]|\\.)*?"/, token: "string" },
        { regex: /(?:black|blue|cyan|green|magenta|red|yellow|white)\b/i, token: "keyword" },
        {
            regex: /(backgroundColor|color)(=)([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/i,
            token: ["variable-4", null, "keyword"],
        },
        {
            regex: /(<|>|=|>=|<=)(-?)(\d*(\.|,)?\d+|Null)/i,
            token: ["variable-5", "variable-5", "variable-5"],
        },
        { regex: /\/\/.*/, token: "comment" },
        { regex: /\/(?:[^\\]|\\.)*?\//, token: "variable-3" },
        { regex: /\/\*/, token: "comment", next: "comment" },
        { regex: /[{[(]/, indent: true, token: "variable-brackets" },
        { regex: /[}\])]/, dedent: true, token: "variable-brackets" },
        { regex: /[a-z$][\w$]*/, token: "variable" },
        { regex: /<</, token: "meta", mode: { spec: "xml", end: />>/ } },
    ],
    comment: [
        { regex: /.*?\*\//, token: "comment", next: "start" },
        { regex: /.*/, token: "comment" },
    ],
    meta: {
        dontIndentStates: ["comment"],
        lineComment: "//",
    },
};
var FormatInput = /** @class */ (function (_super) {
    tslib_1.__extends(FormatInput, _super);
    function FormatInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInputChange = function (value) {
            _this.props.onFormatChange(value);
        };
        return _this;
    }
    FormatInput.prototype.render = function () {
        var _a = this.props, format = _a.format, onFormatChange = _a.onFormatChange, separators = _a.separators, templates = _a.templates, intl = _a.intl;
        return (react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-section" },
            react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-section-title" },
                react_1.default.createElement("span", null, intl.formatMessage({ id: "measureNumberCustomFormatDialog.definition" })),
                templates && (react_1.default.createElement(FormatTemplatesDropdown_1.FormatTemplatesDropdown, { onChange: onFormatChange, separators: separators, templates: templates }))),
            react_1.default.createElement(SyntaxHighlightingInput_1.SyntaxHighlightingInput, { value: format, formatting: formattingRules, onChange: this.handleInputChange, className: "s-custom-format-input" })));
    };
    return FormatInput;
}(react_1.default.PureComponent));
var FormatInputWithIntl = react_intl_1.injectIntl(FormatInput);
exports.default = FormatInputWithIntl;
//# sourceMappingURL=FormatInput.js.map